import i18next from 'i18next';

const messages = {
	softwareUpdateSuccess: i18next.t('push_notification_has_been_sent'),
	softwareUpdateError: i18next.t('device_info_messages_error'),
};

export default messages;
